module.exports = __webpack_public_path__ + "static/media/controls.48d606a7.png";